import Select, { SelectProps } from '@amzn/awsui-components-core/select';
import React from 'react';
import { FilterDropdownHeader } from 'src/components/star-grid/components/FilterDropdownHeader';
import { ReportFilterField } from 'src/components/star-grid/components/ReportFilterField';

interface ReportSelectorProps {
  readonly label: string;
  readonly controlId: string;
  readonly control: SelectProps;
}

export const ReportSelector: React.FC<ReportSelectorProps> = ({ label, controlId, control }) => (
  <ReportFilterField label={label} controlId={controlId} value={control.selectedOption?.label ?? control.placeholder}>
    <Select
      {...control}
      controlId={controlId}
      ariaLabel={label}
      data-testid={controlId}
      expandToViewport
      dropdownRole="dialog"
      renderDropdownHeader={(props) => <FilterDropdownHeader controlId={controlId}>{control.renderDropdownHeader?.(props)}</FilterDropdownHeader>}
    />
  </ReportFilterField>
);
